import { render, staticRenderFns } from "./DatabaseRange.vue?vue&type=template&id=07467540&scoped=true"
import script from "./DatabaseRange.vue?vue&type=script&lang=js"
export * from "./DatabaseRange.vue?vue&type=script&lang=js"
import style0 from "./DatabaseRange.vue?vue&type=style&index=0&id=07467540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07467540",
  null
  
)

export default component.exports